import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_NON_REPORTED_USER_API} from '@app/reactQuery/apis/constants';

export const RQUseGetNonReportedUserData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_non_reports_users_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_NON_REPORTED_USER_API,
        null,
        certificate,
        {divisionId: divisionId},
        signal,
      );
    },
    ...options,
  });
};
